import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Professional } from 'src/app/commons/models/professional.model';
import { Project } from 'src/app/commons/models/project.model';
import { PAGE_SIZE_OPTIONS } from 'src/app/helpers/table.helper';
import * as ProfessionalActions from 'src/app/store/actions/professional.actions';
import { AppState } from 'src/app/store/reducers';
import * as ProfessionalSelectors from 'src/app/store/selectors/professional.selectors';

import { ProfessionalFilters } from '../../../commons/models/professional.model';
import { ProfessionalsColumn } from '../professional-list/professional-list.component';


@Component({
  selector: 'app-professional-selection',
  templateUrl: './professional-selection.component.html',
  styleUrls: ['./professional-selection.component.scss']
})
export class ProfessionalSelectionComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();

  professionals: Observable<Professional[]>;
  filters: Observable<ProfessionalFilters>;
  project: Project;

  @Input()
  defaultFilters: ProfessionalFilters = {
  }

  displayedColumns: ProfessionalsColumn[] = ["user", "dailyCost", "headProject", "actions"];

  pageSizeOptions = PAGE_SIZE_OPTIONS;

  total: Observable<number>;

  constructor(private store$: Store<AppState>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.professionals = this.store$.pipe(select(ProfessionalSelectors.getProfessionals), takeUntil(this.unsubscribe$), map(dtos => dtos ? dtos.map(dto => new Professional(dto)) : null));
    this.total = this.store$.pipe(select(ProfessionalSelectors.getTotalProfessionals), takeUntil(this.unsubscribe$));
    this.filters = this.store$.pipe(select(ProfessionalSelectors.getFilters), takeUntil(this.unsubscribe$));
    if (data) {
      this.defaultFilters = data.defaultFilters;
    }
  }

  load() {
    this.store$.dispatch(ProfessionalActions.loadProfessionals(
      { page: 1, perPage: this.pageSizeOptions[0], filters: this.defaultFilters }));
  }

  sortChange(sort: Sort) {
    this.store$.dispatch(ProfessionalActions.changeSort({ order: sort.active, direction: sort.direction }));
  }

  pageChange(pageEvent: PageEvent) {
    this.store$.dispatch(ProfessionalActions.changePage({ page: pageEvent.pageIndex + 1, size: pageEvent.pageSize, filters: this.defaultFilters }))
  }

  filtersChange(filters: ProfessionalFilters) {
    this.store$.dispatch(ProfessionalActions.changeFilters({ filters }));
  }

  ngOnInit() {
    this.load();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  selectProfessional(professional: Professional) {
    if (professional) {
      this.store$.dispatch(ProfessionalActions.professionalSelected({ professional: professional.toDTO() }));
    }
  }

  close() {
    this.store$.dispatch(ProfessionalActions.closeSelectionDialog())
  }
}
